import { useEffect, useState, useRef } from 'react';
import { Card } from '@/components/ui/card';
import { PageCover, PageBody, SheetHeader } from '@/components/Page';

const LinksBCMED = () => {
  const [isLoading, setIsLoading] = useState(true);
  const formInitialized = useRef(false);

  useEffect(() => {
    // Evitar inicialização duplicada
    if (formInitialized.current) {
      return;
    }

    // Carregar scripts do Tripetto
    const loadScript = (src, id) => {
      return new Promise((resolve, reject) => {
        // Verificar se o script já foi carregado
        if (document.getElementById(id)) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    // Carregar scripts na ordem correta
    const loadTripetto = async () => {
      try {
        await loadScript('https://cdn.jsdelivr.net/npm/@tripetto/runner', 'tripetto-runner');
        await loadScript('https://cdn.jsdelivr.net/npm/@tripetto/runner-autoscroll', 'tripetto-runner-autoscroll');
        await loadScript('https://cdn.jsdelivr.net/npm/@tripetto/studio', 'tripetto-studio');
        
        // Aguardar para garantir que TripettoStudio está disponível
        setTimeout(() => {
          if (window.TripettoStudio && window.TripettoAutoscroll && !formInitialized.current) {
            const container = document.getElementById('tripetto-form-container');
            if (container) {
              // Marcar como inicializado ANTES de renderizar
              formInitialized.current = true;
              
              // Limpar container antes de renderizar
              container.innerHTML = '';
              
              window.TripettoStudio.form({
                runner: window.TripettoAutoscroll,
                token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiYmJ2a0Q2Y3ZVYkhFZUJ3c3Q0UkI0SUVxSDFXUDV3UUhvcmhKanlLbkJGVT0iLCJkZWZpbml0aW9uIjoiUWlQcmhnYzZ2OVlERGgzRlhRYnRoUUlZYlFkUlR2Mmh3RGhUcE8yQkxUMD0iLCJ0eXBlIjoiY29sbGVjdCJ9.ECLuIO9xWhi1ZQZWvsV1_TfQa_BwJSqb0iKpvPIukSU",
                element: container,
                styles: {
                  // Customizar cores para manter o tema do sistema
                  color: '#003eb4', // cobalto, a cor primária do sistema
                  backgroundColor: '#fefefe',
                  dark: {
                    color: '#68a5ff', // primária do tema escuro
                    backgroundColor: '#0f1520'
                  }
                },
                onReady: () => {
                  // Ocultar loading quando o formulário estiver pronto
                  setIsLoading(false);
                }
              });
              
              // Fallback: remover loading após 2 segundos mesmo se onReady não funcionar
              setTimeout(() => {
                setIsLoading(false);
              }, 2000);
            }
          }
        }, 500);
      } catch (error) {
        setIsLoading(false);
      }
    };

    loadTripetto();

    // Cleanup
    return () => {
      // Manter scripts carregados mas resetar flag se componente desmontar
      formInitialized.current = false;
    };
  }, []);

  return (
    <div data-testid="links-bcmed-page">
      <PageCover title="Links BCMED" subtitle="Links e formulários personalizados para os clientes" />
      <PageBody>
        <Card className="overflow-hidden">
          <SheetHeader title="Formulário de links" />
          <div className="p-5">
            {isLoading && <p className="flex min-h-[400px] items-center justify-center text-sm text-gray-500">Carregando o formulário</p>}
            <div id="tripetto-form-container" className={`min-h-[400px] w-full ${isLoading ? 'hidden' : 'block'}`}></div>
          </div>
          <p className="border-t border-border px-5 py-3 text-[13px] text-gray-500">
            O que você envia por aqui é salvo automaticamente.
          </p>
        </Card>
      </PageBody>
    </div>
  );
};

export default LinksBCMED;
